// @flow

import { type PendingIncomingPayment } from './types';
import type { Voucher } from '@tectonics/prs/voucher';

function getVoucher(incomingPayment: PendingIncomingPayment): ?Voucher {
  return incomingPayment['voucher'];
}

export function getSafeVoucher(incomingPayment: PendingIncomingPayment): Voucher {
  const voucher = getVoucher(incomingPayment);

  if (!voucher)
    throw new Error('Voucher: no voucher in incoming payment');

  return voucher;
}
